import React, { useEffect, useState } from "react";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Checkbox,
  Col,
  Row,
  Input,
  List,
  Avatar,
  Skeleton,
  Modal,
  Button,
  Segmented,
  Form,
  Space,
  ColorPicker,
  Upload,
} from "antd";

import { searchPerso } from "../../../../api/Search";
import { BASE_AVATAR_URL } from "../../../../api/Constants";
import { updatePerso } from "../../../../api/Update";
import { useForm } from "antd/es/form/Form";

const SearchBar = (props) => {
  const { onClick } = props;

  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [changeAll, setChangeAll] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  const handleChange = async (e) => {
    setSearchInput(e.target.value);
    if (searchInput.length > 0) {
      setIsloading(true);
      // faire la recherche
      const res = await searchPerso(e.target.value);
      if (res) setSearchResult(res.characters);
      setIsloading(false);
    }
  };

  useEffect(() => {
    setChangeAll(false);
    setSearchInput("");
    setSearchResult([]);
  }, [onClick]);

  const renderRow = (perso) => {
    return (
      <List.Item
        actions={[
          <Button
            onClick={() => {
              onClick(perso, changeAll);
            }}
          >
            Valider
          </Button>,
        ]}
      >
        <Skeleton loading={false} avatar title={false} active>
          <List.Item.Meta
            avatar={<Avatar src={`${BASE_AVATAR_URL}${perso.img}`} />}
            title={<p>{perso.name}</p>}
            description={`${perso.displayName} | ${perso.color}`}
          />
        </Skeleton>
      </List.Item>
    );
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <Input
            allowClear
            addonBefore={<SearchOutlined />}
            onChange={handleChange}
            placeholder="Recherche un personnage"
            value={searchInput}
          />
        </Col>
      </Row>
      <Row>
        <Col span={5}>
          <Checkbox
            checked={changeAll}
            onChange={(e) => setChangeAll(e.target.checked)}
          >
            Appliquer à tous
          </Checkbox>
        </Col>
      </Row>
      <List
        size="small"
        loading={isLoading}
        itemLayout="horizontal"
        dataSource={searchResult}
        renderItem={renderRow}
      />
    </div>
  );
};

const Modifier = (props) => {
  const { onClick, perso, isUpdate } = props;

  const [form] = useForm();

  const [color, setColor] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [name, setName] = useState("");
  const [fileList, setFileList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [changeAll, setChangeAll] = useState(false);

  useEffect(() => {
    form.resetFields();
    setColor(
      perso !== undefined && perso.speaker.color !== undefined
        ? perso.speaker.color
        : "#E8E8E8"
    );
    setDisplayName(perso.speaker.displayName);
    setName(perso.speaker.name);
    setFileList([]);
    setChangeAll(false);
    form.setFieldsValue({
      name: perso.speaker.name || "",
      displayName: perso.speaker.displayName || "",
    });
  }, [perso, form]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const onFinish = async (values) => {
    // console.log("Success:", color, values);
    setIsLoading(true);
    const formData = new FormData();
    if (values.avatar && values.avatar.length > 0)
      formData.append("fileToUpload", values.avatar[0].originFileObj);
    if (color.length > 0) formData.append("color", color);
    if (values.displayName && values.displayName.length > 0)
      formData.append("displayName", values.displayName);

    formData.append("name", name);

    if (isUpdate) {
      const res = await updatePerso(formData);
      console.log(res);
      onClick(res, changeAll);
    }
    setIsLoading(false);
  };

  const uploadProps = {
    multiple: false,
    maxCount: 1,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };

  return (
    <div>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        {perso.speaker.img ? (
          <Avatar src={`${BASE_AVATAR_URL}${perso.speaker.img}`} />
        ) : null}
        <Space align="baseline">
          <Form.Item
            label="Unique Name"
            name="name"
            rules={[{ required: true, message: "Le nom est obligatoire " }]}
          >
            <Input value={name} onChange={(e) => setName(e.target.value)} />
          </Form.Item>
          <Form.Item label="Display Name" name="displayName">
            <Input
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
            />
          </Form.Item>
        </Space>
        <Space direction="horizontal" size={100}>
          <Form.Item label="Couleur" name="color">
            <ColorPicker
              value={color}
              onChange={(c) => setColor(c.toHexString())}
              format="hex"
            />
            <span>
              {typeof color === "string" ? color : color.toHexString()}
            </span>
          </Form.Item>
          <Form.Item
            label="Changer l'image"
            valuePropName="fileList"
            name="avatar"
            getValueFromEvent={normFile}
          >
            <Upload {...uploadProps} listType="picture-card">
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            </Upload>
          </Form.Item>
        </Space>
        <Form.Item>
          <Button loading={isLoading} type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
      <Checkbox
        checked={changeAll}
        onChange={(e) => setChangeAll(e.target.checked)}
      >
        Appliquer à tous
      </Checkbox>
    </div>
  );
};

const PersoModal = (props) => {
  const { modalIsOpen, onClose, onPersoChoose, perso } = props;

  const [isNarrateur, setIsNarrateur] = useState(
    perso && perso.speaker?.name === "Narrateur"
  );
  const [intent, setIntent] = useState(isNarrateur ? "search" : "moa");
  const [title, setTitle] = useState(
    isNarrateur ? "Rechercher" : "Modifier le personnage"
  );

  useEffect(() => {
    const narration = perso && perso.speaker?.name === "Narrateur";
    setIsNarrateur(narration);
    setIntent(narration ? "search" : "moa");
    setTitle(narration ? "Rechercher" : "Modifier le personnage");
  }, [perso]);

  const getIntent = () => {
    switch (intent) {
      default:
      case "moa":
        return (
          <Modifier isUpdate={true} perso={perso} onClick={onPersoChoose} />
        );
      case "search":
        return <SearchBar onClick={onPersoChoose} />;
    }
  };

  return (
    <Modal
      title={title}
      open={modalIsOpen}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button
          key="back"
          onClick={() => {
            onPersoChoose({
              name: "Narrateur",
              color: "#E8E8E8",
            });
          }}
        >
          Transformer en narrateur
        </Button>,
      ]}
    >
      <Segmented
        block
        options={[
          { label: "Modifier ou ajouter", value: "moa", disabled: isNarrateur },
          { label: "Rechercher", value: "search" },
        ]}
        value={intent}
        onChange={setIntent}
      />
      {getIntent()}
    </Modal>
  );
};

export default PersoModal;
